import styled, { css } from 'styled-components';
import { FuelCallout } from '@frete.com/fuel-react';
import { Separator } from '@/components';

export const Form = styled.form`
  ${({ theme: { grid, breakpoint, spacing } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${grid.sm.gutter};
    flex: 1;

    @media (min-width: ${breakpoint.md.minWidth}) {
      gap: ${spacing.km8};
    }
  `}
`;

export const Callout = styled(FuelCallout)`
  max-width: 490px;
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`;

export const FormSeparator = styled(Separator)`
  margin: ${({ theme: { spacing } }) => `${spacing.km4} ${spacing.km0}`};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: ${({ theme: { spacing } }) => spacing.km8};
  flex: 1 1 auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 15.5rem);
`;
